import { AlertOctagon, RefreshCw, FileText, ExternalLink } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

export interface ErrorRecoveryProps {
  title?: string
  message?: string
  errorId?: string
  onRetry?: () => void
  onReport?: () => void
  className?: string
}

export function ErrorRecovery({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Our team has been notified automatically.',
  errorId,
  onRetry,
  onReport,
  className,
}: ErrorRecoveryProps) {
  return (
    <div
      role="alert"
      className={cn(
        'flex min-h-[60vh] items-center justify-center bg-background text-foreground',
        className,
      )}
    >
      <div className="max-w-md px-6 text-center">
        <AlertOctagon className="mx-auto h-10 w-10 text-destructive mb-3" aria-hidden />
        <h2 className="text-xl font-bold">{title}</h2>
        <p className="mt-2 text-sm text-muted-foreground">{message}</p>

        {errorId && (
          <div className="mt-3 text-[11px] text-muted-foreground font-mono">
            Error ID: <span data-testid="error-id">{errorId}</span>
          </div>
        )}

        <div className="mt-5 flex flex-col sm:flex-row items-center justify-center gap-2">
          {onRetry && (
            <Button onClick={onRetry}>
              <RefreshCw className="mr-2 h-4 w-4" aria-hidden />
              Try again
            </Button>
          )}
          {onReport && (
            <Button variant="outline" onClick={onReport}>
              <FileText className="mr-2 h-4 w-4" aria-hidden />
              Report details
            </Button>
          )}
        </div>

        <a
          href="mailto:support@cyberfind.io"
          className="mt-4 inline-flex items-center gap-1 text-xs text-muted-foreground hover:text-foreground transition-colors"
        >
          Contact support <ExternalLink className="h-3 w-3" aria-hidden />
        </a>
      </div>
    </div>
  )
}
